import PropTypes from 'prop-types';
import React, { useCallback, useState, useEffect } from 'react';

import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';

const collapsibleListSectionContentType = (
  <CollapsibleListSectionContent>
    <div />
  </CollapsibleListSectionContent>
).type;
const collapsibleListSectionHeaderType = (
  <CollapsibleListSectionHeader>
    <div />
  </CollapsibleListSectionHeader>
).type;

export const DefaultPreventedCollapsibleListSection = ({
  alwaysOpen = false,
  children,
  className = null,
  header,
  headerClassName = null,
  initiallyClosed = false,
  theme = null,
}) => {
  const [isOpen, setIsOpen] = useState(!initiallyClosed);
  const toggleCollapsed = useCallback(
    (e) => {
      if (alwaysOpen) {
        return;
      }

      if (!e?.defaultPrevented) {
        setIsOpen((isCurrentlyOpen) => !isCurrentlyOpen);
      }
    },
    [alwaysOpen, setIsOpen],
  );
  const childrenArray = React.Children.toArray(children);
  const headerChild = childrenArray.find((child) => child.type === collapsibleListSectionHeaderType);
  const contentChild = childrenArray.find((child) => child.type === collapsibleListSectionContentType);

  useEffect(() => {
    const shouldToggleOpenStateBecauseInitiallyClosedChanged = isOpen === initiallyClosed;
    if (shouldToggleOpenStateBecauseInitiallyClosedChanged) {
      setIsOpen(!isOpen);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [initiallyClosed]);

  return (
    <CollapsibleListSection className={className} open={alwaysOpen || isOpen}>
      {headerChild ? (
        React.cloneElement(headerChild, {
          ...headerChild.props,
          onClick: (e) => {
            toggleCollapsed(e);
            if (headerChild.props.onClick) {
              headerChild.props.onClick(e);
            }
          },
        })
      ) : (
        <CollapsibleListSectionHeader className={headerClassName} onClick={toggleCollapsed} theme={theme}>
          {header}
        </CollapsibleListSectionHeader>
      )}
      {contentChild || <CollapsibleListSectionContent>{children}</CollapsibleListSectionContent>}
    </CollapsibleListSection>
  );
};

DefaultPreventedCollapsibleListSection.propTypes = {
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  theme: PropTypes.oneOf([null, 'white']),
  className: PropTypes.string,
  initiallyClosed: PropTypes.bool,
  alwaysOpen: PropTypes.bool,
  headerClassName: PropTypes.string,
};
